import axios from 'axios'
import type { PortalLicenseSummary } from '@pusula/shared'

/**
 * Pusula Portal API istemcisi. Oturum token'ı yalnızca bellekte (CLAUDE.md: localStorage yasak);
 * sayfa yenilenince "Beni hatırla" çerezinden (`resumePortalSession`) yeniden kurulur.
 */
export const portalApi = axios.create({ baseURL: import.meta.env.VITE_API_URL ?? '/api/v1' })

let token: string | null = null
const listeners = new Set<() => void>()

export function setPortalToken(next: string | null): void {
  token = next
  if (next) portalApi.defaults.headers.common.Authorization = `Bearer ${next}`
  else delete portalApi.defaults.headers.common.Authorization
  for (const l of listeners) l()
}

export const getPortalToken = (): string | null => token

export function onPortalTokenChange(listener: () => void): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

/** "Beni hatırla" çerezinden oturumu yeniden kurar (token yalnızca bellekte; çerez httpOnly). Başarılıysa true */
export async function resumePortalSession(): Promise<boolean> {
  try {
    const res = await axios.post<{ data: { token: string } }>(`${portalApi.defaults.baseURL}/portal/auth/resume`, undefined, { withCredentials: true })
    setPortalToken(res.data.data.token)
    return true
  } catch {
    return false
  }
}

// Oturum düşerse çerezden yenilemeyi dene; olmazsa girişe dön
portalApi.interceptors.response.use(undefined, async (error: { response?: { status?: number }; config?: { _retried?: boolean; headers?: Record<string, string> } }) => {
  const config = error.config
  if (error.response?.status === 401 && token && config && !config._retried) {
    config._retried = true
    if (await resumePortalSession() && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
      return portalApi.request(config as never)
    }
    setPortalToken(null)
  }
  return Promise.reject(error)
})

export interface PortalUser { id: string; email: string; firstName: string; lastName: string }
export interface LegacyCompany {
  tenantId: string; name: string; role: string; isAdmin: boolean; licenseId: string | null
  migrationStatus: string | null; deletionStatus: string | null
}
export interface PortalMe { user: PortalUser; licenses: PortalLicenseSummary[]; legacyCompanies: LegacyCompany[] }
export interface PortalActivation {
  id: string; hostname: string | null; os: string | null; appVersion: string | null; activatedAt: string
  lastHeartbeatAt: string | null; userCount: number | null; status: 'ACTIVE' | 'DEACTIVATED'; deactivatedAt: string | null
}
export interface DesktopRelease {
  version: string; name: string; publishedAt: string; notes: string; prerelease: boolean
  installer: { name: string; url: string; sizeBytes: number } | null
}
